import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import "./NotificationsForm.scss";
import {
  useGetMeQuery,
  useUpdateNotificationSettingsMutation,
} from "../../../features/api/userApiSlice";
import LoadingSpinner from "../../loader/Loader";

const NotificationsForm = () => {
  const { data: user, isLoading, isFetching } = useGetMeQuery();
  const [updateSettings, { isLoading: isUpdating }] =
    useUpdateNotificationSettingsMutation();
  console.log("USER", user);
  const [settings, setSettings] = useState({
    emailMarketing: false,
    newVideos: false,
    promotions: false,
    productUpdates: false,
  });

  useEffect(() => {
    if (user?.notificationSettings) {
      setSettings(user.notificationSettings);
    }
  }, [user]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: checked,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await updateSettings(settings).unwrap();
      toast.success("Notification settings updated successfully!");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update settings.");
    }
  };

  if (isLoading || isFetching) return <LoadingSpinner />;

  return (
    <div className="notifications-form">
      <h3>Email Notifications</h3>
      <p>
        Select which types of email notifications you would like to receive.
      </p>

      <form onSubmit={handleUpdate}>
        <div className="form-group">
          <label className="custom-checkbox-label">
            <input
              type="checkbox"
              name="emailMarketing"
              checked={settings.emailMarketing}
              onChange={handleCheckboxChange}
            />
            <span className="custom-checkbox-visual"></span>{" "}
            {/* Added this span */}
            <span className="checkbox-text">Email Marketing</span>
            <span className="checkbox-description">
              Receive promotional emails, offers, and special deals.
            </span>
          </label>
        </div>

        <div className="form-group">
          <label className="custom-checkbox-label">
            <input
              type="checkbox"
              name="newVideos"
              checked={settings.newVideos}
              onChange={handleCheckboxChange}
            />
            <span className="custom-checkbox-visual"></span>{" "}
            {/* Added this span */}
            <span className="checkbox-text">New Video Releases</span>
            <span className="checkbox-description">
              Be the first to know when new woodworking videos are published.
            </span>
          </label>
        </div>

        <div className="form-group">
          <label className="custom-checkbox-label">
            <input
              type="checkbox"
              name="promotions"
              checked={settings.promotions}
              onChange={handleCheckboxChange}
            />
            <span className="custom-checkbox-visual"></span>{" "}
            {/* Added this span */}
            <span className="checkbox-text">Product Promotions</span>
            <span className="checkbox-description">
              Get updates on new tools, products, and sales from our store.
            </span>
          </label>
        </div>

        <div className="form-group">
          <label className="custom-checkbox-label">
            <input
              type="checkbox"
              name="productUpdates"
              checked={settings.productUpdates}
              onChange={handleCheckboxChange}
            />
            <span className="custom-checkbox-visual"></span>{" "}
            {/* Added this span */}
            <span className="checkbox-text">System Updates</span>
            <span className="checkbox-description">
              Receive important information about changes to our service.
            </span>
          </label>
        </div>

        <button type="submit" disabled={isUpdating} className="save-button">
          {isUpdating ? "Saving..." : "Save Settings"}
        </button>
      </form>
    </div>
  );
};

export default NotificationsForm;
